<script lang="ts" module>
  import type { TeoText } from '@/teoCore/text/TeoText';

  import WordListAssistantComponent from '../WordLists/WordListAssistantComponent.svelte';
</script>

<script lang="ts">
  const { teoText }: { teoText: TeoText } = $props();
</script>

<WordListAssistantComponent {teoText} title="Optimierungen" wordLists={teoText.wordLists.brandFit}
></WordListAssistantComponent>
